/* =========================================================
   LÓGICA DE URGENCIA — contador, stock y barra fija
   Pega esto en:
   Tienda online > Temas > Editar código > Assets > (archivo nuevo) urgency.js
   Luego cárgalo en theme.liquid antes de </body>:
   <script src="{{ 'urgency.js' | asset_url }}" defer></script>
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- 1. Contador regresivo ----------
     Configurable: cuántas horas dura la oferta desde que el visitante
     entra a la página. Cámbialo con data-hours en el HTML si prefieres. */
  const countdownEl = document.querySelector('[data-urg-countdown]');
  if (countdownEl) {
    const hours = parseFloat(countdownEl.dataset.hours || '6');
    let endTime = localStorage.getItem('urgDeadline');

    if (!endTime || parseInt(endTime, 10) < Date.now()) {
      endTime = Date.now() + hours * 60 * 60 * 1000;
      localStorage.setItem('urgDeadline', endTime);
    }
    endTime = parseInt(endTime, 10);

    const hEl = countdownEl.querySelector('[data-h]');
    const mEl = countdownEl.querySelector('[data-m]');
    const sEl = countdownEl.querySelector('[data-s]');

    function tick() {
      const diff = Math.max(0, endTime - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');

      if (diff <= 0) {
        clearInterval(timer);
        countdownEl.querySelector('[data-urg-countdown-label]').textContent = 'Oferta finalizada';
      }
    }
    tick();
    const timer = setInterval(tick, 1000);
  }

  /* ---------- 2. Barra de stock ----------
     Lee la cantidad real del producto desde el atributo data-available
     (lo llenas con Liquid: {{ product.selected_or_first_available_variant.inventory_quantity }})
     y la compara contra un "stock inicial" simulado para pintar la barra. */
  const stockEl = document.querySelector('[data-urg-stock]');
  if (stockEl) {
    const available = parseInt(stockEl.dataset.available || '0', 10);
    const baseline = parseInt(stockEl.dataset.baseline || '50', 10); // stock "de referencia"
    const pct = Math.min(100, Math.max(4, Math.round((available / baseline) * 100)));

    const fillEl = stockEl.querySelector('[data-urg-stock-fill]');
    const textEl = stockEl.querySelector('[data-urg-stock-text]');

    if (fillEl) fillEl.style.width = pct + '%';
    if (textEl) {
      textEl.textContent = available > 0
        ? `¡Solo quedan ${available} unidades a este precio!`
        : 'Últimas unidades reservándose...';
    }
  }

  /* ---------- 3. Barra fija inferior (mobile) ----------
     Se sincroniza con el botón "Comprar ahora" original: al hacer clic
     dispara el mismo formulario de compra del producto. */
  const stickyBar = document.querySelector('[data-urg-sticky]');
  const mainBuyBtn = document.querySelector('[data-urg-main-buy]');

  if (stickyBar && mainBuyBtn) {
    const stickyBuyBtn = stickyBar.querySelector('[data-urg-sticky-buy]');
    if (stickyBuyBtn) {
      stickyBuyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        mainBuyBtn.click();
      });
    }

    // Oculta la barra fija mientras el botón principal está visible en pantalla
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          stickyBar.style.transform = entry.isIntersecting
            ? 'translateY(100%)'
            : 'translateY(0)';
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(mainBuyBtn);
  }
});
